import { ShiftRequest } from 'types/shift-requests';
import { getPickupRequestFormValues } from './pickupRequestForm';
import { extractTimeOffFormValues } from './timeOffRequestForm';

export const getCoverRequestFormValues = (
	editRequest?: Pick<
		ShiftRequest,
		'shiftRequest' | 'note' | 'timeOffReasons' | 'reason' | 'reasonDescription' | 'reasonNote'
	> | null
) => {
	const { shiftId, notes } = getPickupRequestFormValues(editRequest);
	const { reason, reasonDescription, reasonNote } = extractTimeOffFormValues(editRequest);

	return {
		shiftId,
		notes,
		reason,
		reasonDescription,
		reasonNote,
	};
};
